const getWeekKey = (dateStr) => {
  const d = new Date(dateStr);
  const startOfYear = new Date(d.getFullYear(), 0, 1);
  const days = Math.floor((d - startOfYear) / (24 * 60 * 60 * 1000));
  const weekNum = Math.ceil((days + startOfYear.getDay() + 1) / 7);
  return `${d.getFullYear()}-W${String(weekNum).padStart(2, '0')}`;
};

const getMonthKey = (dateStr) => {
  const d = new Date(dateStr);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
};

/**
 * Groups a daily timeSeries array into daily/weekly/monthly buckets.
 * Each entry must have a `date` field (YYYY-MM-DD).
 * Numeric fields are summed. Returns sorted array with a `period` label.
 */
export const groupByTimePeriod = (dailyData, period) => {
  if (!dailyData || dailyData.length === 0) return [];

  const LIMITS = { daily: 30, weekly: 12, monthly: 12 };
  const limit = LIMITS[period] || 12;

  if (period === 'daily') {
    return dailyData.slice(-limit).map(d => ({
      ...d,
      period: d.date.slice(5), // MM-DD
    }));
  }

  const getKey = period === 'weekly' ? getWeekKey : getMonthKey;
  const grouped = {};

  for (const day of dailyData) {
    const key = getKey(day.date);
    if (!grouped[key]) {
      grouped[key] = { period: key, newSubs: 0, canceledSubs: 0, collected: 0, refunded: 0, invoiceCount: 0, refundCount: 0 };
    }
    grouped[key].newSubs += day.newSubs || 0;
    grouped[key].canceledSubs += day.canceledSubs || 0;
    grouped[key].collected += day.collected || 0;
    grouped[key].refunded += day.refunded || 0;
    grouped[key].invoiceCount += day.invoiceCount || 0;
    grouped[key].refundCount += day.refundCount || 0;
  }

  return Object.values(grouped)
    .sort((a, b) => a.period.localeCompare(b.period))
    .slice(-limit);
};
